VjsAdmin.googleForm = (function () {
    const districtGuid = $('.district-info').data('district-guid');
    const platform = $('.platform-info').data('platform-id');
    const init = function () {
        new SettingsClickEvent();
        initDateRagePickers();
    };
    const successAlert = function (alertMessage) {
        const alert = `<div class="alert alert-success" role="alert">\
                            <i class="fa fa-thumbs-o-up" aria-hidden="true"></i>\
                            <span>${alertMessage}</span>\
                            <a href="#" class="close" data-dismiss="alert" aria-label="close">×</a>\
                        </div>`;

        $('.alert-div').html(alert);
    };
    const dangerAlert = function (alertMessage) {
        const alert = `<div class="alert alert-danger" role="alert">\
                            <span>${alertMessage}</span>\
                        </div>`;
        $('.alert-div').html(alert);
    };

    const initDateRagePickers = function () {
        VjsAdmin.initDateRangePickers($('#google-settings-form'));

        // convert database date from UTC to local time in format MM/DD/YYYY
        if (typeof $('#start_date').val() !== 'undefined' && $('#start_date').val() != null && $('#start_date').val() !== '') {
            $('#start_date').val(moment($('#start_date').val()).format('MM/DD/YYYY'));
        }
        if (typeof $('#end_date').val() !== 'undefined' && $('#end_date').val() != null && $('#end_date').val() !== '') {
            $('#end_date').val(moment($('#end_date').val()).format('MM/DD/YYYY'));
        }

        const updateFields = function () {
            const enabled = $('#google-enabled').is(':checked');

            if (+enabled === 1) {
                // $('#google-settings-container').removeClass('disabled');
                $('#google-form #district-clever-id').prop('required', true);
                $('#google-form #sso-instance-guid').prop('required', true);
            }

            if (+enabled === 0) {
                // $('#google-settings-container').addClass('disabled');
                $('#google-form input, #google-form select').prop('required', false);
            }
        };

        $('#google-enabled').on('change', updateFields);
        $('#google-remove-rostering').on('click', (e) => {
            e.preventDefault();
            if (
                window.confirm(
                    'Are you sure you want to remove the connections?\n\n'
                        + 'This will remove all user and license rostering connection data.',
                )
            ) {
                const mybutton = $('#google-remove-rostering');
                const platformId = mybutton.attr('data-platform-id');
                const districtJointGuid = mybutton.attr('data-district-joint-guid');
                const connectionType = mybutton.attr('data-connection-type');
                const req = new VjsUtility.Request();
                req.delete(`/platforms/${platformId}/districts/${districtJointGuid}/rostering/${connectionType}/`)
                    .done(() => {
                        VjsUtility.Notification.success('Rostering connections removed successfully!');
                    })
                    .fail((x) => {
                        VjsUtility.Notification.error(x.responseJSON.data);
                    });
            }
        });

        updateFields();
    };

    const SettingsClickEvent = VjsUtility.Controller.extend({
        events: {
            'click .save-general-settings': 'clickSaveChanges',
            'change .required-checkbox': 'changeRequiredCheckbox',
        },
        clickSaveChanges(e) {
            e.preventDefault();
            const settingsFormData = $('form#google-settings-form').serializeArray();
            let errors = false;
            if ($('#service-account-email').val() === '') {
                $('#service-account-email').removeClass('is-valid').addClass('is-invalid');
                errors = true;
            } else {
                $('#service-account-email').removeClass('is-invalid').addClass('is-valid');
            }
            if ($('#sso-instance-guid').val() === '') {
                $('#sso-instance-guid').removeClass('is-valid').addClass('is-invalid');
                errors = true;
            } else {
                $('#sso-instance-guid').removeClass('is-invalid').addClass('is-valid');
            }
            if ($('#district-google-json').val() === '') {
                $('#district-google-json').removeClass('is-valid').addClass('is-invalid');
                errors = true;
            } else {
                $('#district-google-json').removeClass('is-invalid').addClass('is-valid');
            }
            if (errors) {
                e.stopPropagation();
                return false;
            }
            const req = new VjsUtility.Request();
            req.post(
                Slim.Router.pathFor('platforms.districts.google.edit.post', {
                    platform_id: platform,
                    district_joint_guid: districtGuid,
                }),
                settingsFormData,
            )
                .done(() => {
                    successAlert('Google settings successfully saved! ');
                })
                .fail((x) => {
                    console.log(x.responseJSON.data);
                    dangerAlert('x.responseJSON.data');
                })
                .always(() => {});
        },
        changeRequiredCheckbox(e) {
            const fieldtype = $(e.target).data('field-type');
            if ($(e.target).prop('checked')) {
                $(`select.${fieldtype}`).prop('disabled', true);
            } else {
                $(`select.${fieldtype}`).prop('disabled', false);
            }
        },
    });

    return {
        init,
    };
}());
